import React, { useState, useEffect } from 'react'
import Select from 'react-select'
import { CForm, CTabPane, CFormLabel, CFormSelect, CButton, CRow, CCol, CTable, CTableBody, CTableDataCell, CFormInput, CTableHead, CTableHeaderCell, CTableRow } from '@coreui/react'
import PatientInsuranceFn from '../../services/general/PatientInsuranceAPI.api'
import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config'

const PatientInsurance = ({ insuranceList, insuranceTypes, addedInsurances, setAddedInsurances, selectedDetails, Credentialed = true, allData, setActiveTab, props, index, updateAccordionState, type, patientId }) => {
  const [selectedInsuranceType, setSelectedInsuranceType] = useState('')
  const [insuranceSubTypes, setInsuranceSubTypes] = useState([])
  const [selectedInsuranceSubType, setSelectedInsuranceSubType] = useState('')
  const [selectedInsuranceID, setSelectedInsuranceID] = useState(-1)
  const [policyNumber, setPolicyNumber] = useState(null)
  const [other, setOther] = useState('')

  useEffect(() => {
    if (selectedDetails && selectedDetails.Insurances && insuranceList.length > 0) {
      const insurances = selectedDetails.Insurances.flatMap((insurance) => {
        let newInsurance = JSON.parse(insurance.InsuranceDetails)
        // const matchedInsurance = insuranceList.find(ins => ins.ID == addedInsurances[0].InsuranceID);
        return newInsurance
      })
      if (insurances.length > 0) {
        setAddedInsurances(insurances[0])
        if (type === 'withScheduler') {
          allData.current.Insurance = insurances[0]
        } else {
          updateAccordionState(index, 'Insurance', insurances[0])
        }
        setSelectedInsuranceType(insurances[0]?.Type)
        setSelectedInsuranceSubType(insurances[0]?.SubType)
        let subTypes = insuranceList.filter((ins) => {
          if (ins.Type == insurances[0]?.Type) {
            return ins
          }
        })
        if (subTypes) {
          setInsuranceSubTypes(subTypes)
        }
        setPolicyNumber(insurances[0]?.PolicyNumber)
        setOther(insurances[0]?.Other)
      }
    } else if (addedInsurances) {
      // setAddedInsurances(addedInsurances.Type)
      setSelectedInsuranceType(addedInsurances.Type)
      setSelectedInsuranceSubType(addedInsurances.SubType)
      let subTypes = insuranceList.filter((ins) => {
        if (ins.Type == addedInsurances.Type) {
          return ins
        }
      })
      if (subTypes) {
        setInsuranceSubTypes(subTypes)
      }
      setPolicyNumber(addedInsurances.PolicyNumber)
      setOther(addedInsurances.Other)
    }
  }, [selectedDetails, insuranceList])

  const handleInsuranceTypeSelect = (e) => {
    const selectedType = e.target.value
    setSelectedInsuranceType(selectedType)
    const insurance = insuranceList.filter((ins) => {
      if (ins.Type == selectedType) {
        return ins
      }
    })
    if (insurance) {
      //const subTypes = insurance.SubTypes[selectedType] || [];
      setInsuranceSubTypes(insurance)
    }
  }

  const handleInsuranceSubTypeSelect = (e) => {
    setSelectedInsuranceSubType(e.target.value)
    const insurance = insuranceList.filter((ins) => {
      if (ins.Type == selectedInsuranceType) {
        if (ins.SubType == e.target.value) return ins
      }
    })

    if (insurance.length > 0) {
      //const subTypes = insurance.SubTypes[selectedType] || [];
      setSelectedInsuranceID(insurance[0].ID)
      // setInsuranceSubTypes(insurance);
    }
  }
  const handleAddInsurance = async () => {
    if (!selectedInsuranceType) {
      alert('Please select Insurance Type.')
      return
    }

    if (!selectedInsuranceSubType) {
      alert('Please select Insurance Sub-Type.')
      return
    }

    if (!policyNumber || policyNumber.trim() === '') {
      alert('Please enter a valid Policy Number.')
      return
    }

    const newInsurance = {
      ID: selectedInsuranceID,
      Type: selectedInsuranceType,
      SubType: selectedInsuranceSubType,
      Credentialed: false,
      PolicyNumber: policyNumber || '',
      Other: other || '',
    }

    try {
      let saveInsurance = await PatientInsuranceFn('UPDATE', JSON.stringify([newInsurance]), patientId)
    } catch (error) {
      console.error('error while patinetInsurance')
    }
    setAddedInsurances([newInsurance])

    // allData.current.Insurance = newInsurance;
    if (type === 'withScheduler') {
      allData.current.Insurance = newInsurance
    } else {
      updateAccordionState(index, 'Insurance', newInsurance)
    }
    // setSelectedInsuranceType('');
    // setSelectedInsuranceSubType('');
    // setPolicyNumber('')
    // setOther('')

    // setActiveTab('question')
    toast.success('Insurance save successfully', toastConfig)
  }

  const handleInsuranceCheckboxChange = (insuranceID, field, value) => {
    setAddedInsurances((prevInsurances) => prevInsurances.map((ins) => (ins.ID === insuranceID ? { ...ins, [field]: value } : ins)))
  }

  return (
    <CTabPane visible>
      <CForm className="mt-3">
        <table className="table table-borderless">
          <tbody>
            {/* Primary Insurance */}
            <tr>
              <td className="e-textlabel">
                <CFormLabel>Primary</CFormLabel>
              </td>
              <td>
                <CFormSelect value={selectedInsuranceType} onChange={handleInsuranceTypeSelect}>
                  <option value="">Select Primary Insurance</option>
                  {insuranceTypes.map((type, index) => (
                    <option key={index} value={type}>
                      {type}
                    </option>
                  ))}
                </CFormSelect>
              </td>
            </tr>

            {/* Secondary Insurance */}
            <tr>
              <td className="e-textlabel">
                <CFormLabel>Secondary</CFormLabel>
              </td>
              <td>
                <CFormSelect value={selectedInsuranceSubType} onChange={handleInsuranceSubTypeSelect}>
                  <option value="">Select Secondary Insurance</option>
                  {insuranceSubTypes.map((obj, index) => (
                    <option key={index} value={obj.SubType}>
                      {obj.SubType}
                    </option>
                  ))}
                </CFormSelect>
              </td>
            </tr>

            {/* Policy Number */}
            <tr>
              <td className="e-textlabel">
                <CFormLabel>Policy Number</CFormLabel>
              </td>
              <td>
                <CFormInput type="text" id="PolicyNumber" name="Policy Number" value={policyNumber} onChange={(e) => setPolicyNumber(e.target.value)} />
              </td>
            </tr>
            <tr>
              <td className="e-textlabel">
                <CFormLabel>Other</CFormLabel>
              </td>
              <td>
                <CFormInput type="text" id="Other" name="Other" value={other} onChange={(e) => setOther(e.target.value)} />
              </td>
            </tr>

            <tr>
              <td colSpan="2" className="text-end  e-textlabel">
                <CButton color="primary" className={`py-1 px-4  ${selectedInsuranceSubType && selectedInsuranceType ? '' : 'disabled'}`} onClick={handleAddInsurance} style={{ fontSize: '13px' }}>
                  {'Save'}
                </CButton>
              </td>
            </tr>
          </tbody>
        </table>
      </CForm>
    </CTabPane>
  )
}

export default PatientInsurance
